// extracted by mini-css-extract-plugin
export default {"inputSearchContainer":"SearchInput-SearchInput-module__inputSearchContainer--cYXls"};